import React, { useEffect, useState } from 'react';
import { errorNotify } from '../../../services/toast.notification';
import { getSpeedTest } from '../../../api/api';
import './style.css'
// داده واقعی از JSON
let jsonData = {
  "type": "result",
  "timestamp": "2025-11-05T13:32:40Z",
  "ping": {
    "jitter": 0.223,
    "latency": 2.963,
    "low": 2.577,
    "high": 3.176
  },
  "download": {
    "bandwidth": 3.938632  ,
    "bytes": 1782105,
    "elapsed": 3621,
    "latency": {
      "iqm": 81.84,
      "low": 7.396,
      "high": 366.284,
      "jitter": 49.721
    }
  },
  "upload": {
    "bandwidth": 3.86952  ,
    "bytes": 6487705,
    "elapsed": 13810,
    "latency": null
  },
  "packetLoss": 0,
  "isp": "Iran Telecommunication Company PJS",
  "interface": {
    "internalIp": "192.168.1.118",
    "name": "",
    "macAddr": "4C:72:B9:27:15:BE",
    "isVpn": false,
    "externalIp": "81.16.116.84"
  },
  "server": {
    "id": 18512,
    "host": "rhaspd2.mci.ir",
    "port": 8080,
    "name": "MCI (Hamrahe Avval)",
    "location": "Tehran",
    "country": "Iran",
    "ip": "178.131.122.20"
  },
  "result": {
    "id": "f340a16d-669c-4c1e-8431-0c90f43ac7a2",
    "url": "https://www.speedtest.net/result/c/f340a16d-669c-4c1e-8431-0c90f43ac7a2",
    "persisted": true
  }
};

function polarToCartesian(centerX: number, centerY: number, radius: number, angle: number) {
  const rad = ((angle - 90) * Math.PI) / 180;
  return { x: centerX + radius * Math.cos(rad), y: centerY + radius * Math.sin(rad) };
}

function Gauge({ label, value, max = 1000 }: { label: string; value: number; max?: number }) {
  const radius = 120;
  const centerX = 150;
  const centerY = 150;

  const numbers = [0, 5, 10, 50, 100, 250, 500, 750, 1000];
  const totalTicks = numbers.length - 1;

  const getAngle = (num: number) => {
    const index = numbers.indexOf(num);
    return -90 + (index / totalTicks) * 180;
  };

  const paths = [];
  for (let i = 0; i < numbers.length - 1; i++) {
    const start = numbers[i];
    const end = numbers[i + 1];
    const startAngle = getAngle(start);
    const endAngle = getAngle(end);

    const sections = end - start;
    const anglePerSection = (endAngle - startAngle) / sections;

    for (let j = 0; j < sections; j++) {
      const sectionStartAngle = startAngle + j * anglePerSection;
      const sectionEndAngle = sectionStartAngle + anglePerSection;

      const sectionMaxValue = start + j + 1;
      
      // بخش کسری (اعشاری)
      if (value > start + j && value < sectionMaxValue) {
        const fraction = value - (start + j);
        const midAngle = sectionStartAngle + fraction * anglePerSection;
        const startPos = polarToCartesian(centerX, centerY, radius, sectionStartAngle);
        const endPos = polarToCartesian(centerX, centerY, radius, midAngle);
        paths.push(
          <line
            key={`${i}-${j}-fraction`}
            x1={startPos.x}
            y1={startPos.y}
            x2={endPos.x}
            y2={endPos.y}
            stroke="#3b82f6"
            strokeWidth={20}
          />
        );
        continue;
      }

      if (value >= sectionMaxValue) {
        const startPos = polarToCartesian(centerX, centerY, radius, sectionStartAngle);
        const endPos = polarToCartesian(centerX, centerY, radius, sectionEndAngle);
        paths.push(
          <line
            key={`${i}-${j}`}
            x1={startPos.x}
            y1={startPos.y}
            x2={endPos.x}
            y2={endPos.y}
            stroke="#3b82f6"
            strokeWidth={20}
          />
        );
      }
    }
  }

  // محاسبه زاویه عقربه
  let needleAngle = -90;
  for (let i = 0; i < numbers.length - 1; i++) {
    const start = numbers[i];
    const end = numbers[i + 1];
    if (value >= start && value <= end) {
      const startAngle = getAngle(start);
      const endAngle = getAngle(end);
      const fraction = (value - start) / (end - start);
      needleAngle = startAngle + fraction * (endAngle - startAngle);
      break;
    }
  }

  const needleLength = radius - 10;
  const needleEnd = polarToCartesian(centerX, centerY, needleLength, needleAngle);


  return (
    <svg width={300} height={200}>
      {/* نیم‌دایره پس‌زمینه */}
      <path
        d={`M${centerX - radius},${centerY} A${radius},${radius} 0 0,1 ${centerX + radius},${centerY}`}
        fill="none"
        stroke="#d1d5db"
        strokeWidth={20}
      />

      {/* بخش‌های رنگی proportional */}
      {paths}

      {/* عقربه */}
      <line
        x1={centerX}
        y1={centerY}
        x2={needleEnd.x}
        y2={needleEnd.y}
        stroke="#ef4444"
        strokeWidth={3}
        strokeLinecap="round"
      />

      {/* اعداد */}
      {numbers.map((num, i) => {
        const angle = getAngle(num);
        const pos = polarToCartesian(centerX, centerY, radius + 20, angle);
        return (
          <text key={i} x={pos.x} y={pos.y + 4} textAnchor="middle" fontSize="10" fill="#6b7280">
            {num}
          </text>
        );
      })}

      {/* دایره وسط */}
      <circle cx={centerX} cy={centerY} r={12} fill="#3b82f6" />

      {/* مقدار وسط */}
      <text
        x={centerX}
        y={centerY + 4}
        textAnchor="middle"
        fontSize="14"
        fill="#111827"
        fontWeight="bold"
      >
        {value.toFixed(2)}
      </text>

      {/* برچسب */}
      <text x={centerX} y={centerY + 35} textAnchor="middle" fontSize="14" fill="#6b7280">
        {label}
      </text>
    </svg>
  );
}

function StatBox({ label, value, icon }: { label: string; value: number; icon: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 16px' }}>
      <div style={{ fontSize: 28, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 16, color: '#6b7280', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 'bold', color: '#111827' }}>
        {value.toFixed(2)} {label === 'Ping' ? 'ms' : 'Mbps'}
      </div>
    </div>
  );
}
export interface InputProps {
  url: any
}

 const SpeedTest = ({ url }: InputProps) => {
  const [downloadSpeed,setDownloadSpeed] = useState(0);
  const [uploadSpeed,setUploadSpeed] = useState(0);
  const [ping,setPing] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
 
  const _getSpeedtest = (url: string) => {
    getSpeedTest(url)
      .then((result: any) => {
        let jsonResult = result.data;
        jsonData = jsonResult;
        setDownloadSpeed(jsonResult.download.bandwidth);
        setUploadSpeed(jsonResult.upload.bandwidth);
        setPing(jsonData.ping.latency);
        setIsLoading(false);
        //console.log('backup info is: '+ result.data.json);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })


  }

  useEffect(() => {

    _getSpeedtest(url);
  }, [])
  return (
    <>
    {
      isLoading === false && (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f9fafb',
        fontFamily: 'Inter, sans-serif',
        color: '#111827',
        padding: 24,
      }}
    >

      {/* StatBox ها */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 32 }}>
        <StatBox label="Ping" value={ping} icon={<>📶</>} />
        <StatBox label="Upload" value={uploadSpeed} icon={<>⬆️</>} />
        <StatBox label="Download" value={downloadSpeed} icon={<>⬇️</>} />
      </div>

      {/* نمودار دانلود */}
      <Gauge label="Download" value={downloadSpeed} max={1000} />
    </div>
      )
}
{isLoading && (
  <div style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50px",
    padding: "10px",
    backgroundColor: "#e0f7fa",
    border: "2px solid #00acc1",
    borderRadius: "15px",
    fontSize: "20px",
    color: "#007c91",
    fontWeight: "bold",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  }}>
    این عمیلات ممکن است تا 2 دقیقه زمان نیاز داشته باشد، لطفا شکیبا باشید...
    <div style={{
      display: "flex",
      gap: "5px"
    }}>
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </div>
  </div>
)}
    </>
  );
}

export default SpeedTest;

